import { createRoute } from '@tanstack/react-router';
import { Route as parentRoute } from '../devices/index';
import KioskDeviceDetailsPage from '@/features/kiosk/pages/KioskDeviceDetailsPage';

export const Route = createRoute({
  getParentRoute: () => parentRoute,
  path: '/$id',
  component: KioskDeviceDetailsPage,
});
